import React from "react";
import CountUp from "react-countup";
import AboutImg from "../../assets/about-img.jpeg";

const AboutMe = () => {
  return (
    <>
      {/* About us Section */}
      <section className="my-5">
        <div className="container px-4">
          <div className="row">
            <div className="col-lg-6 col-12 my-2">
              <img src={AboutImg} className="img-fluid" alt="about" />
            </div>

            <div className="col-lg-6 col-12 my-lg-5 px-lg-5 py-lg-5 py-3 my-2 about-right">
              <p className="fs-3 fw-semibold">Introducing Swalok Group</p>
              <p className="para-text text-muted">
                Swalok Group is a 3 years PLUS old Proprietorship Firm
                incorporated on 25-Sep-2021, having its registered office
                located at, Prayagraj, Uttar Pradesh.
                <br />
                <br />
                The major activity of Swalok Group is Services, Sub-classified
                into Creative arts and entertainment activities and is primarily
                engaged in the Other creative arts and and entertainment
                activities. Swalok Group is classified as Micro enterprise in
                the financial year 2021-22. It has its unit situated at
                Prayagraj, Uttar Pradesh.
              </p>
            </div>
          </div>
          {/* row ends */}

          <div className="row mt-lg-4 mt-3">
            <div className="col-lg-3 col-md-6 col-6 mt-3 counter-area">
              <CountUp
                className="counter-num"
                end={400}
                duration={4}
                enableScrollSpy={true}
              />
              <p className="text-muted ms-2">
                Property
                <br />
                Sold
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-6 mt-3 counter-area">
              <CountUp
                className="counter-num"
                end={10}
                duration={4}
                enableScrollSpy={true}
              />
              <p className="text-muted ms-2">
                Years of
                <br />
                Experience
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-6 mt-3 counter-area">
              <CountUp
                className="counter-num"
                end={6}
                duration={4}
                enableScrollSpy={true}
              />
              <p className="text-muted ms-2">
                Total
                <br />
                Sites
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-6 mt-3 counter-area">
              <CountUp
                className="counter-num"
                end={200}
                duration={4}
                enableScrollSpy={true}
              />
              <p className="text-muted ms-2">
                Happy
                <br />
                Clients
              </p>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>

      {/* About us Section ends */}
    </>
  );
};

export default AboutMe;
